import React, {useEffect, useContext, useState} from 'react';
import './sideBar.scss';
import {Link, Outlet, useLocation, useNavigate} from 'react-router-dom';
import LOGO from 'assets/sbaj_logo.png';
import {ReactComponent as USER_ICON} from 'assets/icons/user_icon_1.svg';
import {ReactComponent as NEWS_ICON} from 'assets/dashboard/news_icon.svg';
import {ReactComponent as BUSINESS_EDUCATION_ICON} from 'assets/dashboard/business_education_icon.svg';
import {ReactComponent as DASHBOARD_ICON} from 'assets/dashboard/dashboard_icon.svg';
import {Button, ProfilePic} from 'components';
import {ReactComponent as HAMBURGER_ICON} from 'assets/icons/Hamburger_Icon.svg'
import {ReactComponent as MENU_CLOSE} from 'assets/icons/menu_close.svg'
import {SessionContext} from "providers/SessionProvider";

import useGetUser from "../../operations/queries/useGetUser";

import {useSession} from 'providers/UseSession';
import PageNav from "../page-nav/PageNav";
import {useMediaQuery} from "react-responsive";
import ProgressBar from "../progress-bar/progress-bar";


const pageNavExclude = ["/app/business", "/app/dashboard"];

export const SideBar: React.FC = () => {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const {payload} = useSession();
    const {data: userData} = useGetUser();
    const isTablet = useMediaQuery({query: '(max-width: 1200px)'});
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const {logOutUser} = useContext(SessionContext);


    const [routes, setRoutes] = useState<Array<{ icon: any, name: string, link: string, isActive: boolean }>>([
        {icon: <DASHBOARD_ICON/>, name: "Dashboard", link: "/app/dashboard", isActive: true},
        {icon: <DASHBOARD_ICON/>, name: "Businesses", link: "/app/business", isActive: true},
        {
            icon: <BUSINESS_EDUCATION_ICON/>,
            name: "Business Education",
            link: "/app/education",
            isActive: false
        },
        {icon: <NEWS_ICON/>, name: "News & Events", link: "/app/news", isActive: false},
        {icon: <USER_ICON/>, name: "Account", link: "#", isActive: false},
    ])


    useEffect(() => {
        setRoutes((data) => (data.map((route) => ({...route, isActive: pathname.includes(route.link)}))))
    }, [pathname]);

    const OpenCloseMenu = () => {
        setIsOpen((prev) => !prev);
    }

    return (
        <div className={'side-bar'}>
            {isTablet &&
            <div className="side-bar_nav">
                <div className="side-bar_nav_top">
                    <div className="side-bar_nav_top_left">
                        {isOpen ? <MENU_CLOSE onClick={OpenCloseMenu}/> :
                            <HAMBURGER_ICON className={'hamburger_menu'} onClick={OpenCloseMenu}/>}
                    </div>
                    <div className="side-bar_nav_top_right">
                        <img src={LOGO} alt=""/>
                    </div>
                </div>
                {isOpen &&
                <div className="side-bar_nav_bottom">
                    <h1>Main Links</h1>
                    <div className="side-bar_nav_bottom_main">
                        {routes.map(({name, isActive, link, icon}, index) => (
                            <div key={index}
                                 className={['side-bar_nav_bottom_main_link', pathname.includes(link) ? "side-bar_nav_bottom_main-active" : null].join(' ')}
                                 onClick={() => navigate(link)}>
                                {icon}
                                <div>{name}</div>
                            </div>
                        ))}
                    </div>

                    <div className={'side-bar_nav_bottom_buttons'}>
                        <Button text={'Log Out'} type={'primary'} onclick={logOutUser}/>
                    </div>
                </div>
                }
            </div>
            }

            <div className={'side-bar_wrapper'}>
                {!isTablet && <div className={'side-bar_wrapper_left'}>
                    <div className={'side-bar_wrapper_left_content'}>

                        <div className={'side-bar_wrapper_left_content_top'}>
                            <img src={LOGO} alt=""/>
                        </div>
                        <div className={'side-bar_wrapper_left_content_bottom'}>
                            {routes.map(({name, isActive, link, icon}, index) => (
                                <div
                                    key={index}
                                    className={['side-bar_wrapper_left_content_bottom_route', isActive ? "active_route" : null].join(' ')}
                                    onClick={() => navigate(link)}>
                                    <div className={'side-bar_wrapper_left_content_bottom_route_link'}>
                                        {icon}
                                    </div>
                                    <div className={'side-bar_wrapper_left_content_bottom_route_text'}>
                                        {name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                }

                <div className={'side-bar_wrapper_right'}>
                    <div className={'side-bar_wrapper_right_wrapper'}>

                        {!isTablet && <div className={'side-bar_wrapper_right_wrapper_header'}>
                            <div className={'side-bar_wrapper_right_wrapper_header_greetings'}>
                                <div id={'day'}><span>Good Morning, </span> {userData?.username}</div>
                                <div id={'text'}>
                                    <span>How can we help you today?</span>

                                </div>
                            </div>
                            <div className={'side-bar_wrapper_right_wrapper_header_user'}>
                                <Button text={'logout'} type={'primary'} onclick={logOutUser}/>
                            </div>
                        </div>}
                        {isTablet && <div className={'side-bar_wrapper_right_wrapper_heading'}>
                            {routes.filter((route) => route.isActive)[0].icon}
                            <h1>{routes.filter((route) => route.isActive)[0].name}</h1>
                        </div>}
                        <div className={'side-bar_wrapper_right_wrapper_nav'}>
                            {!pageNavExclude.includes(pathname) && <PageNav/>}
                        </div>
                        <div className={'side-bar_wrapper_right_wrapper_components '}>
                            <Outlet/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SideBar;


